var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNftButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15537",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15537",
    transform: "translate(-11632 -20876)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9551",
    "data-name": "\\u9577\\u65B9\\u5F62 9551",
    width: 77,
    height: 77,
    transform: "translate(11632 20876)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21250",
    "data-name": "\\u30D1\\u30B9 21250",
    d: "M478,185.341a31.286,31.286,0,1,0-42.311,29.281,18.155,18.155,0,0,0-5.965,9.054,3.129,3.129,0,1,0,6.058,1.568,12.739,12.739,0,0,1,2.375-4.319,12.334,12.334,0,0,1,18.173,0,12.761,12.761,0,0,1,2.37,4.3,3.129,3.129,0,0,0,6.063-1.548,18.177,18.177,0,0,0-6.317-9.332A31.288,31.288,0,0,0,478,185.341ZM459.11,197.734a3.129,3.129,0,0,1-4.425,0l-20.671-20.67a3.129,3.129,0,0,1,4.425-4.424L459.11,193.31A3.128,3.128,0,0,1,459.11,197.734Z",
    transform: "translate(11223.57 20723.943)",
    fill: "#a493ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftButton);
export default __webpack_public_path__ + "static/media/nftButton.40efc3edfff848080f0fcb4486da0ce0.svg";
export { ForwardRef as ReactComponent };